 "use client";

import { useEffect, useState } from "react";
import { isContentPreview } from "./locale";

/**
 * Fixed "DRAFT PREVIEW" pill shown while the content_preview localStorage flag
 * is on (unpublished content drafts are overlaid into lesson/course fetches).
 * Renders nothing for normal users. Read on mount only — toggling the flag
 * requires a reload anyway, since content is fetched with it.
 */
export const ContentPreviewBadge = () => {
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        setEnabled(isContentPreview());
    }, []);

    if (!enabled) return null;

    return (
        <div
            style={{
                position: "fixed",
                bottom: 8,
                left: 8,
                zIndex: 9999,
                pointerEvents: "none",
                background: "#b45309",
                color: "#fff",
                borderRadius: 9999,
                padding: "4px 10px",
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: "0.08em",
                boxShadow: "0 1px 4px rgba(0,0,0,0.3)"
            }}
        >
            DRAFT PREVIEW
        </div>
    );
};
